// TODO: Remove mock data when real user data is wired (me query, user directory, etc.)
import type { User } from '~/shared/types/user';
import { UserRole } from '~/shared/types/user';

export const mockUsers: User[] = [
  {
    id: 1,
    email: 'attorney@example.com',
    name: 'Jane Attorney',
    role: UserRole.ATTORNEY,
  },
  {
    id: 2,
    email: 'expert@example.com',
    name: 'Dr. Expert Witness',
    role: UserRole.EXPERT,
    stripeConnectOnboarded: true,
  },
  {
    id: 3,
    email: 'expert2@example.com',
    name: 'Prof. Second Expert',
    role: UserRole.EXPERT,
    stripeConnectOnboarded: false,
  },
  {
    id: 4,
    email: 'expert3@example.com',
    name: 'Dr. Third Expert',
    role: UserRole.EXPERT,
    stripeConnectOnboarded: true,
  },
];
